// Public invitation links prefill ordinary registration; they grant no access or plan.
export function signupContext(params) {
  return {
    email: params.get('email') || '',
    name: params.get('name') || '',
    organization_name: params.get('organization_name') || '',
    app_url: params.get('app_url') || '',
    source: params.get('source') || 'funnel',
  };
}

export function initialSignupForm() {
  let context = {};
  try {
    const params = new URLSearchParams(window.location.search);
    context =
      params.get('signup') === '1' || params.get('signup') === 'true'
        ? signupContext(params)
        : JSON.parse(sessionStorage.getItem('funnelSignupContext') || '{}');
  } catch (_) {
    /* Treat malformed optional prefill as empty. */
  }
  return {
    name: context.name || '',
    email: context.email || '',
    password: '',
    organization_name: context.organization_name || '',
    subdomain: '',
  };
}
